import { useContext } from "react";
import { SettingsContext, SettingsContextProps } from "./context";
import { useSettingsContextController } from "./controller";

const SettingsContextProvider: React.FC<{ children: any }> = ({ children }) => {
  return (
    <SettingsContext.Provider value={{ ...useSettingsContextController() }}>
      {children}
    </SettingsContext.Provider>
  );
};

function useSettings(): SettingsContextProps {
  const context = useContext(SettingsContext);

  if (!context) {
    throw new Error(
      "useSettings must be used within a SettingsContextProvider."
    );
  }

  return context;
}

export { SettingsContextProvider, useSettings };
